export const getCommonIds = (obj: Record<string, string[]>): string[]  => {
  // Get all the array values from the object
  const arrays = Object.values(obj);

  if (arrays.length === 0) {
    return [];
  }
  // Find common elements in all arrays
  return arrays.reduce(
    (common, currentArray) => common.filter((id) => currentArray.includes(id)),
    arrays[0] || []
  );
};

export const splitJoinedStrings = (obj: Record<string, string[]>): Record<string, string[]> => {
  // Loop through each key in the object
  for (let key in obj) {
    // For each key, check if the value is an array
    if (Array.isArray(obj[key])) {
      // Map over the array and check if an element contains a comma
      obj[key] = obj[key].flatMap((item) => {
        // Split the item if a comma is found, otherwise return the item as it is
        return item.includes(",")
          ? item.split(",").map((str) => str.trim())
          : item;
      });
    }
  }
  return obj;
};
